import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref } from "vue"
import _imports_0 from '../../assets/zt_404.png'


const _hoisted_1 = { style: {"background-color":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "my_order_box" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = {
  style: {},
  class: "table_img"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "table_information" }
const _hoisted_9 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  style: {"height":"550px"}
}
const _hoisted_24 = { style: {"display":"flex","justify-content":"center"} }

import leftTemplate from "@/components/leftTemplate.vue";
import { ref } from "vue";
import { ElTable, ElMessage } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRouter } from "vue-router";
interface User {
  date: string;
  name: string;
  address: string;
  katype: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'my_order',
  setup(__props) {

let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
document.title = "标识山西-我的订单";
const page = pageDef;
const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      // TODO: improvement typing when refactor table
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  console.log(value, "这里是");
  multipleSelection.value = val;
};

const tableData = ref([]);
const init = () => {
  Axios(
    "get",
    "/fodder/order/my-list",
    {
      pageNum: page.value.pageNum,
      pageSize: page.value.pageSize,
      orderByColumn: "createTime",
      isAsc: "desc",
    },
    false,
    function (res) {
      tableData.value = res.data.rows;
      page.value.total = res.data.total;
    }
  );
};

init();

//支付页
const router = useRouter();
const goto = (row, type) => {
  router.push({
    path: type,
    query: {
      arry: row.id,
      totalPay: row.price,
      type: "order",
    },
  });
};
//重新下订单
const paymentClick = (row, type) => {
  Axios(
    "post",
    "/fodder/order",
    { materialId: row.materialId, authType: row.authType },
    false,
    function (res) {
      console.log(res);
      let data = res.data.data;
      router.push({
        path: type,
        query: {
          arry: data.id,
          totalPay: data.price,
          type: "order",
          authType: row.authType,
        },
      });
    }
  );
};
//取消按钮
const cancellationClick = (row) => {
  Axios("post", "/fodder/order/cancel/" + row.id, {}, false, function (res) {
    init();
    ElMessage({
      message: "取消成功",
      type: "success",
    });
  });
};
//发票
const invoiceDetail = (row, type) => {
  router.push({
    path: "/invoiceDebit",
    query: {
      arry: row.id,
      type: type,
    },
  });
};

/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftTemplate, { left_tabShow: 'my_order' })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(ElTable), {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          data: tableData.value,
          style: {"width":"100%"},
          onSelectionChange: handleSelectionChange,
          height: "500"
        }, {
          empty: _withCtx(() => [
            (tableData.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { style: {"width":"90%","margin":"0 auto"} }, [
                    _createElementVNode("img", {
                      style: {"width":"100%","margin":"0 auto"},
                      src: _imports_0
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "name",
              width: "250",
              label: "商品名称"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      style: {"width":"100%","height":"100%"},
                      src: scope.row.showImage
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(scope.row.title), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "orderNo",
              width: "220",
              label: "订单号",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "authType",
              width: "220",
              label: "授权信息",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.authType == 'SELF')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " 个人授权 "))
                  : _createCommentVNode("", true),
                (scope.row.authType == 'ENTERPRISE')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 企业授权 "))
                  : _createCommentVNode("", true),
                (scope.row.authType == 'UNION')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 联盟授权 "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "sellerPrice",
              label: "价格",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "price",
              label: "实付",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              property: "status",
              label: "订单状态",
              align: "center",
              width: "100px"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 0)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("待支付")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status == 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      class: "ml-2",
                      type: "info"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("已取消")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status == 3)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      class: "ml-2",
                      type: "danger"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("支付失败")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 3,
                      class: "ml-2",
                      type: "success"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("已支付")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "120",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", {
                        style: {"width":"100px"},
                        class: "topBtn",
                        onClick: ($event: any) => (goto(scope.row, '/myOrderCheckstand'))
                      }, " 支付 ", 8, _hoisted_14),
                      _createElementVNode("div", {
                        class: "cancellationBtn",
                        onClick: ($event: any) => (cancellationClick(scope.row))
                      }, " 取消订单 ", 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                (scope.row.status == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: "cancellationBtn",
                        onClick: ($event: any) => (cancellationClick(scope.row))
                      }, " 取消订单 ", 8, _hoisted_17)
                    ]))
                  : _createCommentVNode("", true),
                (scope.row.status == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (scope.row.sendCount >= 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: ($event: any) => (invoiceDetail(scope.row, 'view')),
                            style: {"width":"100px"},
                            class: "topBtn"
                          }, " 查看发票 ", 8, _hoisted_19))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: ($event: any) => (invoiceDetail(scope.row, 'add')),
                            style: {"width":"100px"},
                            class: "topBtn"
                          }, " 申请发票 ", 8, _hoisted_20))
                    ]))
                  : _createCommentVNode("", true),
                (scope.row.status == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", {
                        style: {"width":"100px"},
                        class: "topBtn",
                        onClick: ($event: any) => (paymentClick(scope.row, '/myOrderCheckstand'))
                      }, " 重新购买 ", 8, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_24, [
          (tableData.value.length != 0)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                "current-page": _unref(page).pageNum,
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_unref(page).pageNum) = $event)),
                "page-size": _unref(page).pageSize,
                "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_unref(page).pageSize) = $event)),
                onSizeChange: sizeChange,
                onCurrentChange: currentChange,
                style: {"margin":"0.4rem 0"},
                background: "",
                layout: "prev, pager, next",
                total: _unref(page).total
              }, null, 8, ["current-page", "page-size", "total"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})